<template>
	<div>
		<hr v-if="isLine"/>
		<div v-else>{{ separation.text }}</div>
	</div>
</template>

<script>
export default {

	props: {
		separation: {
			type: Object,
			required: true
		},
	},

	computed: {
		isLine ()
		{
			return this.separation.type === 'line-pre' || this.separation.type === 'line-post';
		}
	}
}
</script>
